import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/nii-dashboard')({
  component: RouteComponent,
  staticData: {
    title: 'NII Dashboard',
  },
})

function RouteComponent() {
  return <Outlet />
}
